import React from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { SFGridContainer, SFGridItem } from "../../grid";
import { SFPageContainer } from "../../container";
import getStyled from "../../../hooks/getStyled";

import Breadcrumbs from "../../breadcrumbs";

const { styled } = getStyled();

const StyledBreadcrumbsWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  padding: theme.spacing(1.5, 3),
}));

const BreadcrumbSubLayout = (props) => {
  return (
    <SFGridContainer spacing={0}>
      <SFGridItem xs={12}>
        <StyledBreadcrumbsWrapper>
          <Breadcrumbs breadcrumbs={props.breadcrumbs}></Breadcrumbs>
        </StyledBreadcrumbsWrapper>
      </SFGridItem>
      <SFGridItem xs={12}>
        <SFPageContainer>
          <Outlet></Outlet>
        </SFPageContainer>
      </SFGridItem>
    </SFGridContainer>
  );
};

BreadcrumbSubLayout.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      breadcrumb: PropTypes.string,
    })
  ),
};

export default BreadcrumbSubLayout;
